var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("RangePicker", {
            attrs: { range: _vm.selectedRange },
            on: { reloadData: _vm.loadData }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  "hide-default-footer": "",
                  "item-key": "id",
                  "show-select": _vm.checkGate("users-mgmt"),
                  loading: _vm.loadingForm,
                  headers: _vm.headers,
                  items: _vm.wages_report,
                  "items-per-page": -1
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.data-table-select",
                    fn: function(ref) {
                      var item = ref.item
                      var isSelected = ref.isSelected
                      var select = ref.select
                      return [
                        _c("v-simple-checkbox", {
                          attrs: { disabled: item.disabled, value: isSelected },
                          on: {
                            input: function($event) {
                              return select($event)
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.startDate",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                new Date(item.startDate).toLocaleString(
                                  "en-AU",
                                  {
                                    timeZone: "UTC",
                                    weekday: "short",
                                    month: "short",
                                    day: "numeric"
                                  }
                                )
                              )
                          )
                        ]),
                        _vm._v(" -\n                "),
                        _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                new Date(item.endDate).toLocaleString("en-AU", {
                                  timeZone: "UTC",
                                  weekday: "short",
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric"
                                })
                              )
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.amount_paid",
                    fn: function(props) {
                      return [
                        _c(
                          "v-edit-dialog",
                          {
                            attrs: { "return-value": props.item.amount_paid },
                            on: {
                              "update:returnValue": function($event) {
                                return _vm.$set(
                                  props.item,
                                  "amount_paid",
                                  $event
                                )
                              },
                              "update:return-value": function($event) {
                                return _vm.$set(
                                  props.item,
                                  "amount_paid",
                                  $event
                                )
                              },
                              save: function($event) {
                                return _vm.addIndex(props.item)
                              },
                              open: function($event) {
                                return _vm.edit(props.item)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Edit",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: props.item.amount_paid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "amount_paid",
                                              $$v
                                            )
                                          },
                                          expression: "props.item.amount_paid"
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(props.item.amount_paid) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.detail",
                    fn: function(props) {
                      return [
                        _c(
                          "v-edit-dialog",
                          {
                            attrs: { "return-value": props.item.detail },
                            on: {
                              "update:returnValue": function($event) {
                                return _vm.$set(props.item, "detail", $event)
                              },
                              "update:return-value": function($event) {
                                return _vm.$set(props.item, "detail", $event)
                              },
                              open: function($event) {
                                return _vm.edit(props.item)
                              },
                              save: _vm.save
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Reason for pay over or under"
                                        },
                                        model: {
                                          value: props.item.detail,
                                          callback: function($$v) {
                                            _vm.$set(props.item, "detail", $$v)
                                          },
                                          expression: "props.item.detail"
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(props.item.detail) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.editedItem.wages,
                  callback: function($$v) {
                    _vm.$set(_vm.editedItem, "wages", $$v)
                  },
                  expression: "editedItem.wages"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-subheader", [_vm._v("Tips for Staff Transactions")]),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  "hide-default-footer": "",
                  headers: _vm.tipsHeaders,
                  items: _vm.staff_tips,
                  "items-per-page": -1
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.created_at",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                new Date(item.created_at).toLocaleString(
                                  "en-AU",
                                  {
                                    timeZone: "UTC",
                                    weekday: "short",
                                    month: "short",
                                    day: "numeric"
                                  }
                                )
                              )
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.amount",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [_vm._v("$" + _vm._s(item.amount) + " ")])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-subheader", [_vm._v("Total Tips")]),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  attrs: {
                    "hide-default-footer": "",
                    headers: _vm.totalsHeaders,
                    items: _vm.totals,
                    "items-per-page": -1
                  }
                },
                [
                  _c("template", { slot: "body.append" }, [
                    _c("tr", { staticClass: "pink--text" }, [
                      _c("th", { staticClass: "title" }, [_vm._v("Total")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "title" }, [
                        _vm._v("$" + _vm._s(_vm.total_tips))
                      ])
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _vm.checkGate("users-mgmt")
                ? _c(
                    "v-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.split_tips($event)
                        }
                      },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "fieldset",
                        { staticClass: "inline-form right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                type: "Submit",
                                disabled:
                                  _vm.editedItem.wages.length == 0 ||
                                  _vm.total_shared_tips > 0 ||
                                  _vm.total_tips == 0,
                                color: "blue darken-1"
                              }
                            },
                            [_vm._v("Split")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.detail_wagesbyrange.length > 0
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-subheader", [_vm._v("Detail")]),
                  _vm._v(" "),
                  _vm.checkGate("users-mgmt")
                    ? _c("v-select", {
                        attrs: {
                          "max-width": "30%",
                          items: _vm.users,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select a Name"
                        },
                        model: {
                          value: _vm.userDetailId,
                          callback: function($$v) {
                            _vm.userDetailId = $$v
                          },
                          expression: "userDetailId"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.detailHeaders,
                      items: _vm.wagesByUser,
                      "items-per-page": 7
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.workDate",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    new Date(item.workDate).toLocaleString(
                                      "en-AU",
                                      {
                                        timeZone: "UTC",
                                        weekday: "short",
                                        month: "short",
                                        day: "numeric"
                                      }
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          }
                        },
                        {
                          key: "item.tasks",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _vm._l(item.tasks, function(task) {
                                return [
                                  _c("span", [_vm._v(_vm._s(task.name))]),
                                  _vm._v(" \n                    ")
                                ]
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(item.other))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      754802590
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }